import { render, staticRenderFns } from "./ClassLogo.vue?vue&type=template&id=9e060d54&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e060d54')) {
      api.createRecord('9e060d54', component.options)
    } else {
      api.reload('9e060d54', component.options)
    }
    module.hot.accept("./ClassLogo.vue?vue&type=template&id=9e060d54&", function () {
      api.rerender('9e060d54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/navbar/icons/ClassLogo.vue"
export default component.exports